//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    billOfLoads: [],
    searchRequest: {},
  },
  mutations: {
    updateBillOfLoads(state, billOfLoads) {
      state.billOfLoads = billOfLoads;
    },
    updateSearchBillOfLoadRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadBillOfLoads({ commit, state, getters }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

      if (requestToSend.loadIdFrom && !requestToSend.loadIdTo) {
        requestToSend.loadIdTo = requestToSend.loadIdFrom;
      }

      if (requestToSend.etaAssignedStart && !requestToSend.etaAssignedEnd) {
        requestToSend.etaAssignedEnd = moment(requestToSend.etaAssignedStart).endOf('d').toDate();
      }

      if (requestToSend.pickUpStart && !requestToSend.pickUpEnd) {
        requestToSend.pickUpEnd = moment(requestToSend.pickUpStart).endOf('d').toDate();
      }

      requestToSend.driverGroups = getters.flatWithChildDriverGroups(requestToSend.driverGroups);

      //const result = await api.post('/api/w/billOfLoads', requestToSend);
      const result = await newAPIPost('/api/w/billOfLoads', requestToSend);
      commit('updateSearchBillOfLoadRequest', fallbackRequest);
      return commit('updateBillOfLoads', result);
    },
    saveBillOfLoads(store, request) {
      //return api.post('/api/w/billOfLoads/save', request);
      return newAPIPost('/api/w/billOfLoads/save', request);
    },
    confirmBillOfLoads(store, request) {
      //return api.post('/api/w/billOfLoads/confirm', request);
      return newAPIPost('/api/w/billOfLoads/confirm', request);
    },
  },
  getters: {
    getBillOfLoads: state => state.billOfLoads,
  },
};
